import { Grid } from "@material-ui/core";
import {
  InputTextArea,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { DISABLED_BUTTON_SUBMIT, instance2 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState } from "react";
import { RESET_STATE_BOOKING_ANTRIAN, urlCancelBookingJKN } from "./helpers";

const SHOW_BUTTON_CANCEL_JKN = {
  label: "BATAL BOOKING",
  color: "danger",
  state: false,
};

function ModalCancelBookingJKN({
  setShowModal,
  setNewData,
  setFormData,
  formData,
  setShowModalCancel,
}) {
  const [alasan, setAlasan] = useState("");
  const [disabled, setDisabled] = useState(SHOW_BUTTON_CANCEL_JKN);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isNull(alasan)) {
      defaultToastError("Alasan wajib diisi !");
      return false;
    } else {
      setDisabled(DISABLED_BUTTON_SUBMIT);
      try {
        await instance2
          .post(urlCancelBookingJKN, {
            catatan: alasan,
            idbooking: formData.id,
          })
          .then((response) => {
            if (response.data.status === 200) {
              defaultToastSuccess(response.data.message);
              setFormData(RESET_STATE_BOOKING_ANTRIAN);
              setNewData();
            } else {
              defaultToastError(response.data.message);
            }
          })
          .then(() => {
            setDisabled(SHOW_BUTTON_CANCEL_JKN);
            setShowModalCancel(false);
          });
      } catch (error) {
        setDisabled(SHOW_BUTTON_CANCEL_JKN);
        defaultToastError(error?.response?.data?.message);
        setShowModalCancel(false);
      }
    }
  };

  return (
    <Modal title={"Batal Booking"} show={setShowModal}>
      <Grid container spacing={1}>
        <Grid item sm={4}>
          <InputTextMaster
            name='name'
            label='NAMA'
            id='name'
            placeholder='Nama'
            disabled={true}
            readOnly={true}
            value={formData.name}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='no_rm'
            label='NO. RM'
            id='no_rm'
            placeholder='No. RM'
            disabled={true}
            readOnly={true}
            value={formData.id}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='telepon'
            label='TELEPON'
            id='telepon'
            placeholder='Telepon'
            disabled={true}
            readOnly={true}
            value={formData.mobile_phone}
          />
        </Grid>
        <Grid item sm={12}>
          <InputTextArea
            label={"ALASAN"}
            placeholder={"Alasan"}
            name='alasan'
            value={alasan}
            onChange={(e) => {
              setAlasan(e.target.value);
            }}
            id='alasan'
            rows={"3"}
          />
        </Grid>
      </Grid>

      <Grid
        container
        direction='row'
        justifyContent='flex-end'
        style={{
          gap: "1rem",
          marginTop: "0.5rem",
        }}
        alignItems='center'>
        <MasterButton
          type={"button"}
          color={disabled.color}
          name={disabled.label}
          disabled={disabled.state}
          onClick={(e) => handleSubmit(e)}
          size='md'
        />
      </Grid>
    </Modal>
  );
}

export default ModalCancelBookingJKN;
